/**
 * Skinstead product card behaviour.
 * - The floating "Add to cart" in the glass layer proxies its click to the card's
 *   always visible quick add button, so there is exactly one add to cart form per card
 *   and Horizon's AJAX cart and options modal keep working.
 * Progressive enhancement: without this script the bottom button still works and the
 * glass layer simply offers Buy now.
 */
document.addEventListener('click', (event) => {
  const proxy = event.target.closest('[data-ss-proxy-add]');
  if (!proxy) return;
  const card = proxy.closest('.ss-card');
  const real = card && card.querySelector('.ss-card__add .quick-add__button');
  if (!real) return;
  event.preventDefault();
  real.click();
});
